import React from "react";
import VideoPlayer from "../../Components/VideoPlayer/VideoPlayer";
import { useEffect, useState } from "react";
import { getAllUseCaseVideos } from "../../api/api";

const NumberPlateVideo = () => {
  const [videoUrl, setVideoUrl] = useState("");

  useEffect(() => {
    async function fetchVideo() {
      try {
        const data = await getAllUseCaseVideos();
        // //console.log(data?.data?.data);
        const video = data?.data?.data?.find(
          (v) => v._id === "686bb1feab7d4a58aa2e9635"
        );
        // //console.log(video);
        if (video && video.video_path) {
          setVideoUrl(video.video_path);
        }
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    }
    fetchVideo();
  }, []);

  return (
    <div>
      <nav className="navbar navbar-dark bg-dark px-3">
        <span className="navbar-brand">Number Plate Videos</span>
      </nav>

      <VideoPlayer
        videoUrl={"https://visionemptrack.greymatterz.com/" + videoUrl}
        title="Number Plate Video"
        description="Number plate video for the company"
      />
    </div>
  );
};

export default NumberPlateVideo;
